import { Outlet } from '@tanstack/react-router'
import { RouteDocumentTitle } from '@/shared/components/RouteDocumentTitle'
import { PageTitleProvider } from '@/shared/components/PageTitleProvider'

export function RootComponent() {
  return (
    <PageTitleProvider>
      <RouteDocumentTitle />
      <Outlet />
    </PageTitleProvider>
  )
}
